<script>
import useProduct from '@/stores/Product';
import { computed } from 'vue';
import ProductList from '@/components/Product/List';
import ProductItem from '@/components/Product/Item';

export default {
  name: 'Products',
  components: {
    ProductList,
    ProductItem
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    const { getProducts } = useProduct();

    return {
      products: computed(() => getProducts())
    };
  }
};
</script>

<template>
  <ProductList>
    <ProductItem
      v-for="product in products"
      :key="`p${product.uID}`"
      :product="product"
      :disabled="disabled"
    />
  </ProductList>
</template>
